export const GB_FEATURES = {
  EXP_PUPPY_PAGE: 'exp_puppy_page',
  EXP_PROFILE_V_APP_3: 'exp_profile_v_app_3',
  REL_BREEDER_STATS_PAGE: 'rel_breeder_stats_page'
};
